
<app-modal></app-modal>
<section class='container my-3'>
  <picture>
    <source media="(max-width: 799px)" srcset="assets/img/gif-mobile.gif" width="320" height="70" />
    <source media="(min-width: 800px)" srcset="assets/img/gif-desktop.gif" width="980" height="86" />
    <!-- <img src="assets/img/gif-mobile.gif" alt="Banner de aniversario Segurnet" class="center" /> -->
  </picture>
</section>

<!-- <app-modal></app-modal> -->
<section class='container mt-4'>
  <div class='row'>
    <div>
      <h1 class='txtBold text-uppercase'>La cobertura perfecta para ti</h1>
      <h2 class='txtGris txtBold subtitulo'>Más que un corredor, somos un aliado efectivo, nos dedicamos a conocer a
        fondo tus objetivos y así ofrecerte soluciones y productos de seguros, satisfaciendo tus necesidades reales.
      </h2>
    </div>

    <div class='col-12 mt-2'>
      <h3 class='txtBold cotizadores__title'>Empieza a cotizar tu seguro</h3>

      <div class='d-flex row flex-lg-row text-center px-1 p-lg-0'>

        <!-- Seguros de prop -->
        <div *ngFor='let item of services; ' class='mr-4 col-3 col-md-2 col-lg-1 cotizadores__containerBtn'
          (mouseover)='changeSrc(item.srcLightImg)' (mouseout)='backSrc()'
          (click)='item.active ? goToform(item.formUrl) : getAlert(item.formUrl)'>
          <div class='cotizadores__btnIcon'>
            <img src="assets/img/{{item.srcIcon}}.svg" alt="Icono del boton para ir a cotizar un seguro de propiedad"
              width="50" height="50">
          </div>
          <p class='txtGris txtBold cotizadores__description'>{{item.description}}</p>
        </div>
      </div>

    </div>

    <!-- imagen que cambia -->
    <div class='col-12 d-flex justify-lg-content-end justify-content-md-center p-0' *ngIf='isDesktop'>
      <div>
        <picture>
          <source media="(min-width: 800px)" [srcset]='imgUrl' width="980" height="469" />
          <img [src]='imgUrl' alt="Icono de la oficina de Segurnet" class="center dinamicImage-change" width="980"
            height="469" id='imgChange' />
        </picture>
      </div>
    </div>
  </div>
</section>

<hr class='line mt-5 mx-auto'>
<!-- SEGMENTO 2 - COMO SOLICITAR POLIZA CON SEGURNET -->

<section class='mt-5'>
  <div class='container-fluid bgSegur'>
    <h3 class='txtBold text-center'>¿Cómo solicitar una Póliza de Seguros con nosotros?</h3>
  </div>

  <div class='container mx-auto row mt-lg-5 mt-3 d-flex justify-content-center'>

    <!-- Web  -->
    <div class='col-lg-4 col-10 p-3'>
      <div class='d-flex justify-content-center'>
        <picture>
          <source media="(max-width: 799px)" srcset="assets/img/web.png" width="150" height="110" />
          <source media="(min-width: 800px)" srcset="assets/img/web.png" width="209" height="152" />
          <img src="assets/img/web.png" alt="Icono de una pagina web para la seccion del boton cotizar ahora"
            class="center" loading="lazy" width="150" height="110" />
        </picture>
      </div>
      <p class='"txtBold mt-2 text-center'><strong>Página Web</strong></p>
      <p class=' text-center'>Ofrecemos el servicio de cotización de Póliza en linea de una manera facil y rapida. Tan
        solo tienes que clicar en el botón "Cotiza ahora"</p>
      <div class='d-flex justify-content-center'>
        <button type='button' class='btn btn-segurnet' [routerLink]='"cotiza"'>Cotiza ahora</button>
      </div>
    </div>

    <!-- Llamada -->
    <div class='col-lg-4 col-10 p-3'>
      <div class='d-flex justify-content-center'>
        <picture>
          <source media="(max-width: 799px)" srcset="assets/img/llamanos.png" width="150" height="110" />
          <source media="(min-width: 800px)" srcset="assets/img/llamanos.png" width="191" height="139" />
          <img src="assets/img/llamanos.png" alt="Icono de medios de contact: llamada, whatsApp o correo" class="center"
            loading="lazy" width="191" height="139" />
        </picture>
      </div>
      <p class='txtBold mt-3 text-center'> <strong>Llamada, correo o Whatsapp</strong></p>
      <p class='text-center'>Estamos disponibles a través de distintas plataformas para brindarte el mejor de los
        servicios. Anímate a escribirnos a
        <a href='emailstring' class="td-none"><span class='txtBold txtSegu'>info@segurnet.com.do </span></a>
        igualmente puedes llamarnos al:
        <a href='callUs' class="td-none"><span class='txtBold txtSegu'>809-620-2524</span></a>
        o mejor escríbenos por
        <a (click)='goWhatapp()'><span class='txtBold txtSegu'>whatsApp!</span></a>
      </p>
    </div>

    <!-- Oficina -->
    <div class='col-lg-4 col-10 p-3'>
      <div class='d-flex justify-content-center'>
        <picture>
          <source media="(max-width: 799px)" srcset="assets/img/segurnetMovil.png" width="255" height="120.28" />
          <source media="(min-width: 800px)" srcset="assets/img/segurnet.png" width="349" height="159" />
          <img src="assets/img/segurnet.png" alt="Icono de la oficina de Segurnet" class="center" loading="lazy"
            width="349" height="159" />
        </picture>
      </div>
      <p class='txtBold mt-2 text-center'> <strong>Visitándonos en nuestra oficina</strong></p>
      <p class='text-center'>También puedes visitarnos en nuestra oficina ubicada en la <span
          class='txtBold txtSegu'>Calle Viriato Fiallo #24, Santo Domingo.</span> Horario: <span
          class='txtBold txtSegu'>Lunes a Viernes de 8:00 a.m. a 5:30 p.m. y los Sábados de 8:00 a.m. a 12:30
          p.m.</span></p>
      <div class='d-flex justify-content-center'>
        <button type='button' class='btn btn-segurnet' (click)='verMap()'>Ver mapa</button>
      </div>
    </div>
  </div>
</section>

<hr class='line mt-5 mx-auto'>

<!-- SEGMENTO 3 - nuestros servicios  -->
<section class='container-fluid px-0 mt-5'>
  <div class='container-fluid bgSegur'>
    <h3 class='txtBold text-center'>Nuestros Servicios</h3>
  </div>
  <div class='container mb-5'>
    <!-- Generales -->
    <div class='row mt-5'>
      <div class='row p-0 col-lg-8'>
        <div class='col-12 col-md-12 ps-lg-5 mx-auto mx-lg-0 text-center text-lg-start'>
          <h4>Para ti, <span class='txtBold'>tenemos</span> las<br><span class='txtcomf'>coberturas más
              completas</span><br>y atractivas proporcionándote<br><span class='txtBold text-uppercase txtSegu'>los
              menores costos</span>.</h4>
          <p>Más que un servicio de simple intermediación, somos un aliado efectivo, dedicándonos a conocer a fondo tus
            metas.</p>
        </div>
        <div class='col-12 col-md-12 col-lg-12 p-0 p-lg-2  text-center text-md-start'>
          <div class='row pt-2 ps-md-5'>
            <div class='col-12 col-md-5'>
              <p class='text-uppercase txtBold text-uppercase'><span class='txtSegu'>---</span> seguros de vehículos
                <br><span class='txtSegu'>---</span> seguros de salud
                <br><span class='txtSegu'>---</span> seguros de vida
              </p>
            </div>

            <div class='col-12 col-md-5'>
              <p class='text-u txtBold text-uppercase'><span class='txtSegu'>---</span> seguros de propiedades
                <br><span class='txtSegu'>---</span> seguros de viajes
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class='col-lg-4 col-12 d-flex align-content-center'>
        <picture class="mx-auto">
          <source media="(max-width: 799px)" srcset="assets/img/servPersonalesMovil.png" width="250" height="144" />
          <source media="(min-width: 800px)" srcset="assets/img/servPersonales.png" width="350" height="201" />
          <img id="ourSevImg" src="assets/img/servPersonales.png" alt="Imagen de la seccion de seguros coporativos"
            width="350" height="201" loading="lazy">
        </picture>
      </div>
    </div>
  </div>

  <!-- masivos y corporativos -->
  <div class='container-fluid bgGris d-flex justify-content-center px-0 pb-4'>
    <div
      class='container row pt-5 px-1 d-flex justify-content-center justify-content-lg-start text-center text-lg-start  ms-lg-5 ps-lg-3'>
      <div class='col-12 col-md-10 col-lg-8'>
        <h4>Para ti, cliente corporativo, diseñamos <span class='txtBold'>las mejores soluciones <br>y productos
          </span><span class='txtcomf'>a la medida, </span>que satisfacen las necesidades<br><span
            class='txtBold text-uppercase txtSegu'>personalizadas de tu negocio</span></h4>
        <p>y proteger tanto a la empresa, como también lo más importante que hay en ella, sus empleados.</p>
      </div>
      <div class='col-12 col-md-8 text-md-left'>
        <p class='text-u txtBold text-uppercase text-md-start'><span class='txtSegu'>---</span> Pequeñas y medianas
          empresas (PYMES)<br><span class='txtSegu'>---</span> Grupos Empresariales, Industrias y Multinacionales</p>
      </div>
      <div class='col-12 col-md-4 col-lg-5 d-flex flex-wrap align-content-center center'>
        <picture class="mx-auto">
          <source media="(max-width: 799px)" srcset="assets/img/sevCorporativoMovil.png" width="250" height="144" />
          <source media="(min-width: 800px)" srcset="assets/img/servCorporativo.png" width="398" height="229" />
          <img src="assets/img/servCorporativo.png" alt="Imagen de la seccion de seguros coporativos" width="398"
            height="229" loading="lazy">
        </picture>
      </div>

      <div class='col-12 col-md-10 col-lg-7 px-2 p-md-0 p-lg-2 text-center'>
        <hr>
        <h4><span class='txtBold'>Desarollamos</span> productos de seguros para <span
            class='txtBold text-uppercase txtSegu'>la venta en grandes volúmenes</span>.</h4>
        <p>Como complemento a tus servicios principales, incrementando el nivel de satisfacción de tus clientes. Ponemos
          además a tu disposición nuestra propia plataforma digital para la gestión y administración de estos servicios.
        </p>
        <p class='text-u txtBold text-uppercase'><span class='txtSegu'>---</span> Seguros Masivos<br><span
            class='txtSegu'>---</span> Canales alternos</p>
      </div>
    </div>
  </div>
</section>


<!-- SEGMENTO 4 - calificacion -->
<section class='container px-0 mt-5 mb-5'>
  <div class='d-flex justify-content-center'>
    <picture class="mx-auto">
      <source media="(max-width: 799px)" srcset="assets/img/estrellasMovil.png" width="300" height="55" />
      <source media="(min-width: 800px)" srcset="assets/img/estrellas.png" width="365" height="67" />
      <img src="assets/img/estrellas.png" alt="Calificacion 4.8 estrellas segurnet" width="365" height="67"
        loading="lazy">
    </picture>
  </div>
  <h5 class='txtBold text-center mt-2 mx-3'>El 95% de nuestros clientes nos han calificado como una empresa de 5
    estrellas en Google</h5>

  <!-- <app-reviews></app-reviews> -->

</section>
